import React, { useEffect, useState } from 'react'
import FilesView from '../../../../Components/Utils/FilesView';
import { CreateButton } from '../../../../Components/Utils/Buttons';
import { useNavigate, useParams } from 'react-router-dom';

function ViewEquipmentsContract({ item, data, open, onCancel, onCreateClick }) {
       const displayItem = data;
       const { contractsViewId,id } = useParams();
  const navigate = useNavigate();

       
  const [filePathList, setFilePathList] = useState([]);

    useEffect(() => {
      if (
        data?.equipmentImage !== null &&
        data?.equipmentImage !== "None" &&
        data?.equipmentImage !== "[]"
      ) {
        setFilePathList(data?.equipmentImage?.length>0 ? data?.equipmentImage : []);
      }
    }, [data]);

  //    const handleCreateClick = () => {
  //   if (module === "Cont. Equipt.") {
  //     onCreateClick && onCreateClick();
  //   } else {
  //     navigate(`/Contract-management/contracts/equipments/${contractsViewId}/equipDetails`); // Navigate to the create equipment page
  //   }
  // };

  const handleCreateClick = () => {
  navigate(`/Contract-management/contracts/equipments/${contractsViewId}/equipDetails/${displayItem?.id}`);
};

    return (
      <div className="w-full flex flex-col flex-wrap gap-5">
        <div className='my-2 w-full'>
          <p className='text-[13px] font-medium text-mainColor-400 py-1'>Category</p>
          <p className='text-xs text-mainColor-400'>{displayItem?.categoryName || "-"}</p>
        </div>
        <div className='flex gap-10 w-full'>
          <div className='my-2 w-[30%]'>
          <p className='text-[13px] font-medium text-mainColor-400 py-1'>Equipment</p>
          <p className='text-xs text-mainColor-400'>{displayItem?.equipmentName || "-"}</p>
        </div>
        <div className='my-2 w-[30%]'>
          <p className='text-[13px] font-medium text-mainColor-400 py-1'>Unit</p>
          <p className='text-xs text-mainColor-400'>{displayItem?.unit || "-"}</p>
        </div>
        <div className='my-2 w-[30%]'>
          <p className='text-[13px] font-medium text-mainColor-400 py-1'>Quantity</p>
          <p className='text-xs text-mainColor-400'>{displayItem?.quantity || "-"}</p>
        </div>
        {/* <div className='my-2 w-[30%]'>
          <p className='text-[13px] font-medium text-mainColor-400 py-1'>Brand</p>
          <p className='text-xs text-mainColor-400'>{displayItem?.brand || "-"}</p>
        </div>
        <div className='my-2 w-[30%]'>
          <p className='text-[13px] font-medium text-mainColor-400 py-1'>Model No</p>
          <p className='text-xs text-mainColor-400'>{displayItem?.model || "-"}</p>
        </div> */}
        </div>

       <CreateButton handleClick={handleCreateClick} label="View Details" />
        {/* {data?.equipmentImage?.length > 0 && (<>
        <p className=" p-1 text-xs font-medium text-[#111537]">
                  Attachments
                </p>
                <div className="overflow-y-scroll h-28 rounded-lg p-2">

                  <div className="w-full flex gap-2 flex-wrap ">
                    {data?.equipmentImage &&
                      filePathList.map((imgs, idx) => {
                        console.log("img", imgs);
                        return (
                          <FilesView fileView={imgs} key={idx} />
                        );
                      })}
                  </div>
                </div>
                </>)} */}
      </div>
    );
  }
export default ViewEquipmentsContract